<template>
    <div id='documentation' style='height: 50vh;'>
        <h1>Documentation</h1>

        <h2 v-if="isAdmin()"> Profil Administrateur :</h2>
        <h2 v-else >Profil Expert linguistique :</h2>
        <div >
            <ul>
                <li><a class="lienActif" href="https://prolexis.com/images/DIAGONAL/Documentation/WebServiceDoc/PriseenmainWSutilisateur.pdf" target="_blank" rel="noopener noreferrer">Prise en main (utilisateur)</a> : fonctionnement général de ProLexis</li>
                <li><a class="lienActif" href="https://prolexis.com/images/DIAGONAL/Documentation/WebServiceDoc/PriseenmainWSexpert.pdf" target="_blank" rel="noopener noreferrer">Prise en main (expert linguistique)</a> : fonctionnement général de ProLexis et présentation des Soumissions</li>
                <li v-if="isAdmin()"><a class="lienActif" href="https://prolexis.com/images/DIAGONAL/Documentation/WebServiceDoc/PriseenmainWSadmin.pdf" target="_blank" rel="noopener noreferrer">Prise en main (admin)</a> : fonctionnement général de ProLexis et présentation du menu administration</li>
                <li><a class="lienActif" href="https://www.prolexis.com/images/DIAGONAL/Documentation/prolexis/GuideUtilisateur.pdf" target="_blank" rel="noopener noreferrer">Guide de l’utilisateur</a> : fonctionnement détaillé de ProLexis et de ses analyses</li>
                <li v-if="isAdmin()"><a class="lienActif" href="https://prolexis.com/images/DIAGONAL/Documentation/WebServiceDoc/DocumentationAdminWebServiceAPI.zip" target="_blank" rel="noopener noreferrer">Documentation de l’API d’administration de ProLexis WebService</a></li>
            </ul>
        </div>
        <!--
        <a class="lienActif" :href="publicPath+'/documentations/Interface Correction Web - Guide Utilisateur.pdf'" target="_blank" rel="noopener noreferrer">Guide Utilisateur</a>
        <br />
        <a class="lienActif" :href="publicPath+'/documentations/Interface Correction Web - Guide Utilisateur.pdf'" target="_blank" rel="noopener noreferrer">User Guide</a>
        -->
    </div>
</template>

<script>
    import FctUtils from '@/components/FctUtils';
    import { RoleEnum } from '../classes/enums';

    export default { 
        name:"Documentation",
        components: { },
        mixins: [FctUtils],
        data () {
            return {
                publicPath: process.env.BASE_URL
            }
        },
        computed:{
            role() {
                return this.$store.state.currentUser.role;
            }
        },
        methods : {
            isAdmin() {
                return this.role == RoleEnum.ADMIN.value || this.role == RoleEnum.SUPERADMIN.value
            },

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
